import { render, staticRenderFns } from "./SigniModal.vue?vue&type=template&id=020fe936&scoped=true"
import script from "./SigniModal.vue?vue&type=script&lang=js"
export * from "./SigniModal.vue?vue&type=script&lang=js"
import style0 from "./SigniModal.vue?vue&type=style&index=0&id=020fe936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020fe936",
  null
  
)

export default component.exports